import {Pipe, PipeTransform} from '@angular/core';
import {DateEntryMeta, Todesdatum} from "../../../core/personstamm-api";

const sprintf = require("sprintf-js").sprintf;

@Pipe({
  name: 'dayMonthYearDate'
})
export class DayMonthYearDatePipe implements PipeTransform {

  transform(value: DateEntryMeta | Todesdatum): string {
    if (!value) {
      return '';
    }
    const day = value.day ? value.day : 0;
    const month = value.month ? value.month : 0;
    const year = value.year ? value.year : 0;
    if (day === 0 && month === 0) {
      return sprintf('%04d', year);
    }
    return sprintf('%02d.%02d.%04d', day, month, year);
  }
}
